export const getPropertyOf = (data, accessor) => {
    if (accessor?.includes('.')) {
        const split = accessor.split('.');
        const oldFormData = { ...data[split[0]] };
        return oldFormData[split[1]];
    }
    return data[accessor];
};
